/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

const zh_hans1_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

const zh_hant1_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

const fr_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

const de_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

const ja_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

const ko_provider_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const provider_minecraft = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.provider_minecraft(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("provider_minecraft", locale)
	if (locale === "en") return en_provider_minecraft(inputs)
	if (locale === "zh-Hans") return zh_hans1_provider_minecraft(inputs)
	if (locale === "zh-Hant") return zh_hant1_provider_minecraft(inputs)
	if (locale === "fr") return fr_provider_minecraft(inputs)
	if (locale === "de") return de_provider_minecraft(inputs)
	if (locale === "ja") return ja_provider_minecraft(inputs)
	return ko_provider_minecraft(inputs)
};